module.exports = __webpack_public_path__ + "static/Marek-profile-4eed605ccdadd465376d43a2cb5874d8.png";